import { useEffect, useState } from 'react';

export const useLineLiffAccessToken = (liffId: string | undefined) => {
  const [lineAccessToken, setLineAccessToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    import('@line/liff').then(async (_liff) => {
      const liff = _liff.default;

      const isNotLiffInitialized = () => !liff.id;

      const initLineLiffApp = async () => {
        try {
          if (liffId && isNotLiffInitialized()) {
            await liff.init({ liffId });
          }
        } catch (error) {
          // liffが初期化できなくてもuserにfeedbackする必要はないのでconsole.errorしておく
          console.error('liff init error', (error as any).message);
        }
      };

      const setToken = async () => {
        setIsLoading(true);
        try {
          // dynamic importでないとwindow is not definedになるため
          if (liff.isInClient()) {
            await liff.ready;
            const token = liff.getAccessToken();
            setLineAccessToken(token);
          }
        } catch (error) {
          console.error((error as any).message);
        } finally {
          setIsLoading(false);
        }
      };
      await initLineLiffApp();
      await setToken();
    });
  }, [liffId]);
  return { lineAccessToken, isLoading };
};
